<template>
    <SectionContentLayout
      :state="contacts_controller.state.events['fetch_foreground']"
      content_class="contacts-group-form"
      invalid_text='contacts.person.invalid'
      invalid_icon='fas fa-address-card'
      error_text="contacts.list.error"
    >
      <template #close>
        <ActionButton
            @click="onClose()"
            class="close"
            icon="fas fa-times-circle"
            v-tooltip='"global.actions.back"'
        />
      </template>

      <template #header>
          <ContentTitle
            :title="route.name === 'contacts-group-add' ? 'contacts.form.group_add' : 'contacts.form.group_edit'"
          />
      </template>

      <template #actions_success>
          <ActionButton
            @click="onGroupSave()"
            v-tooltip='"global.actions.save"'
            icon='fas fa-save'
            :disabled="contacts_controller.state.events['save_group'] === 'loading'"
          />
      </template>

      <template #content_success>
        <form @keyup.enter="onGroupSave()">
            <fieldset>
                <InputText
                  input_id="cg_name"
                  input_name="name"
                  :input_required="true"
                  v-model:input_value="group.name"
                  :input_value="group.name"
                  :input_focus="true"
                  label_text="contacts.form.name"
                  label_tooltip="contacts.form.required_field"
                  error_text="contacts.form.error_required"
                  :input_invalids="properties_validation.invalid"
                  @change="validateAfterSubmit()">
                </InputText>
            </fieldset>
            <div class="submit-desktop">
                <ActionButton
                  @click='onGroupSave()'
                  class="main-action"
                  icon="fas fa-save"
                  text="global.actions.save"
                  :loading="contacts_controller.state.events['save_group'] === 'loading'"
                />
            </div>
        </form>
      </template>
    </SectionContentLayout>
</template>

<script setup>
  import {ref, reactive}              from 'vue';
  import {onBeforeMount, onUnmounted} from 'vue';
  import {defineProps}                from 'vue';
  import {useRoute,useRouter}         from 'vue-router';
  import SectionContentLayout         from '@/vue/Layouts/Sections/SectionContentLayout.vue';
  import ContentTitle                 from '@/vue/Elements/Content/ContentTitle.vue';
  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue';
  import ContactsController           from '@/js/Contacts/ContactsController';
  import PropertiesValidation from '@/js/Shared/Validation/PropertiesValidation';
  import InputText from '@/vue/Elements/Inputs/InputText.vue';

  const props = defineProps({
    contacts_view : {}
  })

  const route                 = useRoute();
  const router                = useRouter();
  const contacts_controller   = ContactsController
  const group                 = ref();
  const first_submit          = ref(true);
  const properties_validation = reactive(new PropertiesValidation({
    name:  {
      required: true,
    },
  }));

  onBeforeMount(async () => {
    contacts_controller.state.on('fetch_foreground', 'success', onLoad);
    contacts_controller.broadcaster.on('contacts-deleted', onContactsDeleted);
  })

  onUnmounted(async () => {
    contacts_controller.state.destroy('fetch_foreground', 'success', onLoad);
    contacts_controller.broadcaster.destroy('contacts-deleted', onContactsDeleted);
  })

  const onLoad = () => {
    setGroup();
  }

  const onClose = () => {
    close();
  }

  const onContactsDeleted = (contact_ids) => {
    if(contact_ids.includes(route.params.contact_id)){
      close();
    }
  }

  const onGroupSave = async () => {
    setFirstSubmit(false);

    if (validateFields() === false) {
      scrollToRef(properties_validation.getFirstInvalid());
      return;
    }

    if (await contacts_controller.saveGroup(group.value) === false) {
      return;
    }

    let id = route.params.contact_id || contacts_controller.contacts.all.getLastAdded().id;
    router.push('/contacts/group/info/' + id);
  }

  const setGroup = () => {
    group.value = contacts_controller.contacts.getGroupClone(route.params.contact_id || null);
  }

  const setFirstSubmit = (value) => {
    first_submit.value = value;
  }

  const validateFields = () => {
    return properties_validation.validateObject(group.value);
  }

  const validateAfterSubmit = () => {
    if (first_submit.value === true) {
      return;
    }

    return validateFields();
  }

  const scrollToRef = (id) => {
    document.getElementById(`cg_${id}`).scrollIntoView({block: "end", behavior: "smooth"});
  }

  const close = () => {
    let path = '/contacts';

    if (route.params.contact_id) {
      path += '/group/info/' + route.params.contact_id;
    }

    router.push(path);
  }
</script>